import React from 'react';
import PropTypes from 'prop-types';

const Checkbox = ({
  id,
  name,
  value,
  className,
  containerClassName,
  label,
  onChange,
  checked,
  readOnly
}) => {
  id = id || `${name || ''}-default-checkbox-id`;
  return (
    <div className={`${containerClassName || ''} checkbox-custom checkbox-default`}>
      <input
        type='checkbox'
        id={id}
        onChange={readOnly ? null : onChange}
        checked={checked}
        className={id || className || 'custom-field-checkbox'}
        name={name || ''}
        value={value}
      />
      <label htmlFor={id}>{label || ''}</label>
    </div>
  )
}

export default Checkbox;



// WEBPACK FOOTER //
// ./src/browser/components/ui/checkbox.js